import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Workflow = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.5 3.5H13V2H11V3.5H7.5C6.39543 3.5 5.5 4.39543 5.5 5.5V6.5C5.5 7.60457 6.39543 8.5 7.5 8.5H11V9.5H7.5C6.39543 9.5 5.5 10.3954 5.5 11.5V12.5C5.5 13.6046 6.39543 14.5 7.5 14.5H11V15.5H7.5C6.39543 15.5 5.5 16.3954 5.5 17.5V18.5C5.5 19.6046 6.39543 20.5 7.5 20.5H11V22H13V20.5H16.5C17.6046 20.5 18.5 19.6046 18.5 18.5V17.5C18.5 16.3954 17.6046 15.5 16.5 15.5H13V14.5H16.5C17.6046 14.5 18.5 13.6046 18.5 12.5V11.5C18.5 10.3954 17.6046 9.5 16.5 9.5H13V8.5H16.5C17.6046 8.5 18.5 7.60457 18.5 6.5V5.5C18.5 4.39543 17.6046 3.5 16.5 3.5ZM16.5 5.5H7.5L7.5 6.5H16.5V5.5ZM16.5 11.5H7.5L7.5 12.5H16.5V11.5ZM7.5 17.5H16.5V18.5H7.5L7.5 17.5Z"
      fill="currentColor"
    />
  </Icon>
));

export default Workflow;
